<script setup>
import { computed } from 'vue';
import { useMenuState, generateMenuItemId } from '@/composables/useMenuState';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  fontawesome: {
    type: String,
    default: '',
  },
  /** Optional stable ID; auto-generated if not provided */
  itemId: {
    type: String,
    default: '',
  },
});

const { isItemOpen, toggleItem } = useMenuState();

// Resolve the unique ID for this dropdown
const resolvedId = computed(() => props.itemId || generateMenuItemId());

const isOpen = computed(() => isItemOpen(resolvedId.value));

const toggleMenu = () => {
  toggleItem(resolvedId.value);
};

defineExpose({
  props,
  isOpen,
  toggleMenu,
  resolvedId,
});
</script>
<template>
  <ul class="dropdown navigation mb-0">
    <li class="dropdown ms-1" :class="{open: isOpen}">
      <div class="d-flex align-items-center justify-content-start rounded menu-dropdown-toggle" @click.stop="toggleMenu">
        <div class="icon ms-1">
          <i :class="fontawesome"></i>
        </div>
        <span class="menu-title text-truncate py-1 mx-1 ms-2" id="menuHide">{{ props.title }}</span>
        <i class="fa-solid fa-chevron-right fa-2xs mainButton px-1"></i>
      </div>
      <slot></slot>
    </li>
  </ul>
</template>
<style scoped>
.mainButton {
  transform-origin: center;
  flex-shrink: 0;
  transition: transform .15s ease-in-out;
  will-change: transform;
  margin-left: auto;
}

.dropdown.open .mainButton {
  transform: rotate(90deg);
}

.menu-dropdown-toggle {
  margin-right: 10px;
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  user-select: none;
}

.dropdown.open>.menu-dropdown-toggle {
  background-color: rgba(138, 138, 138, 0.11);
  transition: 0.5s ease-in-out;
}

.dropdown {
  cursor: pointer;
  position: static;
}

.vertical-layout.vertical-menu-modern.menu-collapsed .main-menu #menuHide {
  height: 0px;
  visibility: hidden;
}

.vertical-layout.vertical-menu-modern.menu-collapsed .main-menu.expanded #menuHide {
  height: auto;
  visibility: visible;
}

/* Controla exibição do conteúdo do dropdown */
.dropdown :deep(ul.dropdown-submenu),
.dropdown :deep(ul.navigation) {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}

.dropdown.open :deep(ul.dropdown-submenu),
.dropdown.open :deep(ul.navigation) {
  max-height: 1000px;
}
</style>